import styles from "./index.module.scss";
import { sample_01_mp4 } from "@/assets/videos";
import { useCommonStore } from "@/stores";
import { VideoPlayer } from "@/components";
import { useEffect } from "react";
import { placeholder_webp } from "@/assets/images";

const SampleVideo = () => {
  const isMute = useCommonStore(state => state.isMute);
  const isPlayResult = useCommonStore(state => state.isPlayResult);
  const setIsMute = useCommonStore(state => state.setIsMute);
  const setIsPlayResult = useCommonStore(state => state.setIsPlayResult);
  const updatePlayState = useCommonStore(state => state.updatePlayState);
  const safariInfo = useCommonStore(state => state.safariInfo);

  useEffect(() => {
    return () => {
      setIsPlayResult(false);
    }
  }, []);

  return (
    <div
      className={styles["root"]}
    >
      <VideoPlayer
        videoClassName={styles["custom_video"]}
        isMute={isMute}
        isPlay={isPlayResult}
        videoSrc={sample_01_mp4}
        poster={safariInfo?.isSafari ? "" : placeholder_webp}
        isSample={!safariInfo?.isSafari}
        setIsMute={setIsMute}
        setIsPlay={setIsPlayResult}
        onPlay={() => updatePlayState(false)}
      ></VideoPlayer>
    </div>
  )
}

export default SampleVideo;